import { useEffect } from 'react';

export const useKeyboard = (
    key: string,
    callback: () => void,
    condition = true
) => {
    useEffect(() => {
        if (!condition) return;

        const handleKeyPress = (event: KeyboardEvent) => {
            if (event.key === key) {
                callback();
            }
        };

        document.addEventListener('keydown', handleKeyPress);
        return () => document.removeEventListener('keydown', handleKeyPress);
    }, [key, callback, condition]);
};

